import { useState, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import FindMultyStudentPopup from "@/pages/comp/basic/student/popup/find_multy";
import SelectDateArrTwoCalendarArea from "@/pcomponents/common/crud/calendar/area/select_date_arr_two_cal";
import Style from "./css/style.module.css";
import { useLocation, useNavigate } from "react-router";
import StuArea from "./area/stu_area";
import TodoContent from "./area/todo_content";
import OptionArea from "./area/option_area";
import MakeTodoWriteFunc from "@/pages/comp/plan/todo/common/make_todo/func/make_todo_write";

function WriteTodoWordArea(props: any) {
  let myProps = {
    select_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    stu_seq_arr: [],
    calback: (inData: any) => { },
    closePopup: () => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const [stu_info_arr, set_stu_info_arr] = useState([]);
  const [select_date, set_select_date] = useState(myProps.select_date);
  const [select_date_arr, set_select_date_arr] = useState([]);
  const [able_days_of_week, set_able_days_of_week] = useState([1, 2, 3, 4, 5]);
  const default_todo_data: any = {
    a_sort: "homework",//study
    a_sort_det: "",
    a_success_sort: "amount",
    a_amount_sort: "개",
    a_success_amount: 10,
    a_success_amount_start: 0,
    a_subject: "영어",
    a_title: "",
    a_content: "",
    a_par_id: "",
    a_par_seq: "",
    row_view_success_amount: "",
    row_view_success_amount_start: "",
  };
  const [todo_data_arr, set_todo_data_arr] = useState<any>([]);
  let default_make_option: any = {
    "one_day_amount": 20,
  };
  const [make_option, set_make_option] = useState<any>(default_make_option);
  const [todo_write_arr, set_todo_write_arr] = useState<any>([]);

  const [popupData, setPopupData] = useState<any>({
    isOpen: false,
    sort: "find_stu",//find_stu
    row_num: 0,
    key_str: "",
    s_except_user_seq: [],
    has_header: true,
    title: "학생찾기",
    width: "900px",
    height: "100%",
  });

  useEffect(() => {
    get_stu_info_arr();
  }, []);

  const get_stu_info_arr = () => {
    let search_stu_seq_arr = [];
    if (myProps.stu_seq_arr) {
      for (let i = 0; i < myProps.stu_seq_arr.length; i++) {
        if (!strFunc.is_empty(myProps.stu_seq_arr[i])) {
          search_stu_seq_arr.push(myProps.stu_seq_arr[i]);
        }
      }
    }

    if (strFunc.is_empty(search_stu_seq_arr)) {
      return false;
    }

    let list_form_json = {
      "s_seq": search_stu_seq_arr,
      "s_addon_stu_grade_name": "1",
      "order_id": "a_stu_name",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', list_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_stu_info_arr(response.data["data"]["info_arr"]);
        } else {
          alert("검색 중 오류." + response.data["msg"]);
          props.closePopup();
        }
      });
  };

  const make_todo_write_plan = (inData: any) => {
    let opt_obj = {
      todo_data_arr: todo_data_arr,
      make_option: make_option,
      able_days_of_week: able_days_of_week,
      select_date: select_date,
      select_date_arr: select_date_arr,
      is_period: false,
      ...inData
    };
    if (opt_obj.todo_data_arr.length == 0) {
      alert("내용 선택이 필요합니다.");
      return false;
    }
    if (strFunc.is_empty(make_option.one_day_amount)) {
      alert("하루분량이 필요합니다.");
      return false;
    }
    let tmp_todo_data_arr = [
      ...opt_obj.todo_data_arr
    ];

    for (let i = 0; i < tmp_todo_data_arr.length; i++) {
      let todo_data = tmp_todo_data_arr[i];
      tmp_todo_data_arr[i]["row_view_success_amount"] = todo_data["a_success_amount"];
      tmp_todo_data_arr[i]["row_view_success_amount_start"] = todo_data["a_success_amount_start"];
    }

    opt_obj.make_option = {
      ...opt_obj.make_option,
      apply_day: opt_obj.able_days_of_week.join(","),
      reserve_start_date: opt_obj.select_date,
    };
    if (opt_obj.select_date_arr.length > 0) {
      opt_obj.make_option.reserve_start_date = opt_obj.select_date_arr[0];
    }
    if (opt_obj.is_period) {
      opt_obj.make_option.distribute_standard = "period";
      opt_obj.make_option.reserve_end_date = opt_obj.select_date_arr[opt_obj.select_date_arr.length - 1];
      let except_date_arr: any = [];
      let start_date = opt_obj.make_option.reserve_start_date;
      let end_date = opt_obj.make_option.reserve_end_date;
      let ing_date = start_date;
      let is_while_loop = true;
      let max_loop_cnt = 1000;
      let loop_cnt = 0;
      while (is_while_loop) {
        loop_cnt++;
        if (DateFunc.get_date_format(new Date(ing_date), "Y-m-d") <= DateFunc.get_date_format(new Date(end_date), "Y-m-d")) {
          is_while_loop = true;
        } else {
          is_while_loop = false;
        }
        if (loop_cnt > max_loop_cnt) {
          is_while_loop = false;
        }
        if (is_while_loop) {
          if (strFunc.str_in_array(ing_date, opt_obj.select_date_arr) == -1) {
            except_date_arr.push(ing_date);
          }
          ing_date = DateFunc.get_date_format(DateFunc.get_change_date(new Date(ing_date), 'day', +1), "Y-m-d");
        }
      }
      opt_obj.make_option.except_date_arr = except_date_arr;
    }

    let todo_write_arr = MakeTodoWriteFunc.get_make_todo_write({
      todo_content_arr: tmp_todo_data_arr,
      make_option: opt_obj.make_option
    });
    set_todo_write_arr(todo_write_arr);
    if (opt_obj.is_period&&todo_write_arr.length>0) {
      set_make_option({
        ...make_option,
        one_day_amount:todo_write_arr[0]["a_success_amount"],
      });
    }
    let change_select_date_arr: any = [];
    for (let i = 0; i < todo_write_arr.length; i++) {
      let todo_write = todo_write_arr[i];
      let row_select_date = todo_write["a_reserve_start_date"].substring(0, 10);
      if (strFunc.str_in_array(row_select_date, change_select_date_arr) == -1) {
        change_select_date_arr.push(row_select_date);
      }
    }
    set_select_date_arr(change_select_date_arr);
  };

  const make_todo_by_pan_write = () => {
    if (strFunc.is_empty(user.comp_seq)) {
      alert("로그인이 필요합니다.");
      return false;
    }
    if (stu_info_arr.length == 0) {
      alert("학생 선택이 필요합니다.");
      return false;
    }
    if (todo_write_arr.length == 0) {
      alert("스케줄 작성내용이 없습니다.");
      return false;
    }
    for (let i = 0; i < todo_write_arr.length; i++) {
      let todo_write = todo_write_arr[i];
      if (strFunc.is_empty(todo_write["a_sort"])) {
        alert("구분입력 필요.");
        return false;
      }
      if (strFunc.is_empty(todo_write["a_subject"])) {
        alert("과목입력 필요.");
        return false;
      }
    }

    if (!confirm("스케줄을 등록 하시겠습니까?")) {
      return false;
    }
    let stu_seq_arr: any = [];
    for (let i = 0; i < stu_info_arr.length; i++) {
      stu_seq_arr.push(stu_info_arr[i]["a_seq"]);
    }

    let formJsonData = {
      "m_comp_seq": user.comp_seq,
      "stu_seq_arr": stu_seq_arr,
      "todo_write_arr": todo_write_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo/make_by_custom_and_user', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("등록되었습니다.");
          if (confirm("맞춤플랜달력 페이지로 이동하시겠습니까?")) {
            navigate('/comp/plan/calendar', {
              state: {
                stu_seq_arr: stu_seq_arr,
                stu_info_arr: stu_info_arr,
              }
            });
          }
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const open_find_stu_popup = (inData: any) => {
    let opt_obj = {
      ...inData
    };
    let s_except_user_seq: any = [];
    for (let i = 0; i < stu_info_arr.length; i++) {
      let stu_info = stu_info_arr[i];
      s_except_user_seq.push(stu_info["a_seq"]);
    }
    setPopupData({
      ...popupData,
      isOpen: true,
      has_header: true,
      sort: "find_stu",
      title: "학생찾기",
      s_except_user_seq: s_except_user_seq,
      ...opt_obj
    });
  };

  const callback_stu_find_popup = (inData: any) => {
    let optObj = {
      info_arr: [],
      row_num: 0,
      key_str: "",
      ...inData,
    };
    let tmp_stu_info_arr: any = [...stu_info_arr];
    let pre_stu_seq_arr: any = [];
    for (let i = 0; i < tmp_stu_info_arr.length; i++) {
      pre_stu_seq_arr.push(tmp_stu_info_arr[i]["a_seq"]);
    }
    //추가
    for (let i = 0; i < optObj.info_arr.length; i++) {
      let stu_info: any = optObj.info_arr[i];
      if (strFunc.str_in_array(stu_info["a_seq"], pre_stu_seq_arr) == -1) {
        tmp_stu_info_arr.push(stu_info);
      }
    }
    set_stu_info_arr(tmp_stu_info_arr);
  };

  return (
    <div className={Style.popup_wrap}>
      <div className={Style.sub_title}>
        학생
        {(myProps.stu_seq_arr.length == 0 || stu_info_arr.length == 0) &&
          <button className="ml-1 btn-m btn-dark" onClick={() => { open_find_stu_popup({}); }}>찾기</button>
        }
      </div>
      <StuArea
        stu_info_arr={stu_info_arr}
        set_stu_info_arr={set_stu_info_arr}
        Style={Style}
      ></StuArea>
      <TodoContent
        todo_data_arr={todo_data_arr}
        set_todo_data_arr={(inData: any) => {
          set_todo_data_arr(inData);
          make_todo_write_plan({ todo_data_arr: inData });
        }}
        default_todo_data={default_todo_data}
        Style={Style}
      ></TodoContent>
      <div className='mt-1'>
        <OptionArea
          make_option={make_option}
          set_make_option={(inData: any) => {
            set_make_option(inData);
            make_todo_write_plan({ make_option: inData });
          }}
        ></OptionArea>
      </div>
      <div className='mt-1'>
        <SelectDateArrTwoCalendarArea
          select_date={select_date}
          set_select_date={set_select_date}
          select_date_arr={select_date_arr}
          set_select_date_arr={(inData: any) => {
            set_select_date_arr(inData);
            if (inData.length > 0) {
              make_todo_write_plan({ select_date_arr: inData, is_period: true });
            }
          }}
          able_days_of_week={able_days_of_week}
          set_able_days_of_week={(inData: any) => {
            set_able_days_of_week(inData);
            make_todo_write_plan({ able_days_of_week: inData });
          }}
        ></SelectDateArrTwoCalendarArea>
      </div>
      <div className="btn-box-center mt-2">
        <button className="btn btn-line-gray" onClick={() => { make_todo_by_pan_write(); }}>맞춤플랜작성</button>
        <button className="btn btn-line-gray" onClick={() => { myProps.closePopup(); }}>닫기</button>
      </div>
      {
        popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} title_bar_style={{ borderBottom: 0 }}
          content_div_style={{ padding: "10px 0px" }} y={"0"} has_header={popupData.has_header} >
          {popupData.sort == "find_stu" &&
            <FindMultyStudentPopup
              listOpt={{
                s_except_user_seq: popupData.s_except_user_seq,
                s_is_use_online_textbook: "1"
              }}
              row_num={popupData.row_num}
              key_str={popupData.key_str}
              is_multi_select_by_click={true}
              is_show_use_oneline_textbook_search={true}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
              callBackData={callback_stu_find_popup}
            ></FindMultyStudentPopup>
          }
        </LayerPopup>
      }
    </div >
  );
};
export default WriteTodoWordArea;